export default __webpack_public_path__ + "static/DIBS-Letters-new-6e2fe480fbe5494d02f98759b2f25311.svg";